export const SET_ADMIN_LABEL_FACETS = 'SET_ADMIN_LABEL_FACETS';
